import { Flex } from '@shared/components';

import QSetReviewResultOverviewCard, {
  type QSetReviewResultOverviewCardProps,
} from '../qset-review-result-overview-card/qset-review-result-overview-card';

interface QSetReviewResultOverviewCardGroupProps {
  cards: QSetReviewResultOverviewCardProps[];
}

export default function QSetReviewResultOverviewCardGroup(
  props: QSetReviewResultOverviewCardGroupProps,
) {
  const { cards } = props;
  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(4),
        width: '100%',
      })}
    >
      {cards.map((card, index) => (
        <Flex sx={{ width: '100%' }} key={index}>
          <QSetReviewResultOverviewCard {...card} />
        </Flex>
      ))}
    </Flex>
  );
}
